import { EditorState } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import MUIRichTextEditor from 'mui-rte'
import React, { FC, ReactElement, useContext } from 'react'
import {
    Controller,
    ControllerRenderProps,
    useFormContext,
    UseFormMethods
} from '../../Vendor/react-hook-form/dist/index.ie11'
import { RichTextEditor as RichTextEditorLanguage } from '../../../i18n'
import CLanguageHandler from '../../NonReact/Languages/LanguageHandler'
import { EMPTY_STRING } from '../../NonReact/constants/Common'
import { CommonFormContext, FormContextType } from '../Common/Contexts/CommonFormContext'

type Props = {
    label: string
    name: string
}

export const RichTextEditor: FC<Props> = ({ label, name }: Props): ReactElement => {
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(RichTextEditorLanguage.NAME)

    const commonForm: Nullable<FormContextType> = useContext(CommonFormContext)
    const { control }: UseFormMethods = useFormContext()

    const props = {
        control,
        name,
        defaultValue: EMPTY_STRING,
        render: ({ onChange }: ControllerRenderProps<Record<string, unknown>>): ReactElement => (
            <div className='rich-text-editor-wrapper'>
                <MUIRichTextEditor
                    label={language.get(RichTextEditorLanguage.RTE_Label)}
                    toolbarButtonSize='small'
                    controls={['bold', 'italic', 'underline', 'numberList', 'bulletList']}
                    onChange={(value: EditorState): void => {
                        if (commonForm?.handleFormChange) {
                            commonForm?.handleFormChange(name)
                        }

                        onChange(stateToHTML(value.getCurrentContent()))
                    }}
                />
            </div>
        )
    }

    return (
        <div className='rich-text-editor'>
            <label className='label'>{label}</label>
            <Controller {...props} />
        </div>
    )
}
